import { render, staticRenderFns } from "./SerahTerimaGadaiLunas.vue?vue&type=template&id=07c810c2&scoped=true&"
import script from "./SerahTerimaGadaiLunas.vue?vue&type=script&lang=js&"
export * from "./SerahTerimaGadaiLunas.vue?vue&type=script&lang=js&"
import style0 from "./SerahTerimaGadaiLunas.vue?vue&type=style&index=0&id=07c810c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c810c2",
  null
  
)

export default component.exports